import { NotificationRequest } from './aux/notification-request';
import { editCheck, newCheck } from './aux/notification-types';

export class Notification {
  constructor(
    public hash: string,
    public type: string,
    public date: number,
    public request: NotificationRequest,
    public read: boolean,
    public answered: boolean
  ) { }

  isConfirmable() {
    return !!this.request && !this.answered;
  }
  isEditRequest() {
    return this.type === editCheck;
  }

  isNewRequest() {
    return this.type === newCheck;
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/notification.ts